export default {
    title: `Mes stats sociales`,
    legend: `Moyennes calculées sur le dernier mois`,
    link: `Voir toutes mes statistiques`,
};
